<template>
    <div>
        <title>总数</title>
        <article class="cardArticle">
            <!--S 公用头部切换-->
            <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
            <!--E 公用头部切换-->
            <!-- 激活记录总数 -->
            <ActivationRecord></ActivationRecord>
        </article>
        
    </div>
</template>
<script>
export default {
    name:'CompanyRecordTotal',
    components: {
      CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
      ActivationRecord: resolve => require(["@/components/common/ActivationRecord.vue"], resolve),
    },
    
    data(){
        return{
            currentTit:1, //当前选中菜单
            batchcode:this.$route.query.batchcode,
        }
    },
    // ==================================== 方法 ====================================
    methods:{
        
    },
    created() {
    },
    mounted () {
    },
    destroyed(){ 
    }
}
</script>
<style scoped>
.cardArticle{
    position: relative;
    padding: 84px 20px 20px 20px;
    height: calc(100% - 169px);
}
</style>


// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/CompanyRecordTotal.vue